import { h } from '@stencil/core';
import dynamicBannerStore from '../../conversational-search-banners/dynamic-banner/dynamic-banner-store';
import type { ConversationalSearchMessagesMediatorsWrapper } from './mediators-wrapper';
import { newMessageHandler } from './mediators-wrapper-helpers';

export const renderCorrectMediator = (context: ConversationalSearchMessagesMediatorsWrapper) => {
    if (dynamicBannerStore.get('invoked') && dynamicBannerStore.get('data') && context.isPreloadVariant) {
      return (
        <uiaas-search-widget-conversational-search-messages-preload-mediator
          searchQuery={context.searchQuery}
          labelProvider={(e, f) => context.labelProvider(e, f)}
          preloadCallback={(query) => newMessageHandler(query, context, true)}
        />
      );
    }

    return (
      <uiaas-search-widget-conversational-search-messages-initial-mediator
        searchQuery={context.searchQuery}
        labelProvider={(e, f) => context.labelProvider(e, f)}
        acceptanceCallback={(query) => newMessageHandler(query, context, true)}
      />
    );
};
